<div class="pickup-button">
    <div class="pickup-button__inner">
        <ng-template #optionTemplate let-item="item">
            <div class="pickup-button__option-template" *ngIf="isFutureOrder">
                <ng-container *ngIf="item?.Id === -1">
                    {{item.Name}} <shared-icon class="pickup-button__icon -next" icon="next"></shared-icon>
                </ng-container>
                <ng-container *ngIf="item?.Id >= 0">
                    {{item | pickupLabel}}
                </ng-container>
            </div>
            <div class="pickup-button__option-template" *ngIf="!isFutureOrder">
                {{item.Name}}
            </div>
        </ng-template>

        <shared-drop-down (onToggle)="dropdownToggle($event)" (onSelected)="dropdownSelected($event)"
            [projection]="projection ? projection : (mode === 'filter' ? 'local' : 'global')" [selected]="selected"
            [options]="options" [optionTemplate]="optionTemplate" position="br" [width]="dropdownWidth">

            <shared-btn *ngIf="triggerType === 'button'" [disabled]="isDisabled"
                [size]="size" [iconLeft]="iconLeft" [iconRight]="iconRight">
                {{label}}
            </shared-btn>

            <shared-link role="button" [title]="label" *ngIf="triggerType === 'link'"
                [disabled]="disabled || !options || options.length === 0" [size]="size">
                <shared-icon class="pickup-button__icon -left" *ngIf="iconLeft" [icon]="iconLeft"></shared-icon>
                {{label}}<shared-icon *ngIf="iconRight" [icon]="iconRight" class="pickup-button__icon -right">
                </shared-icon>
            </shared-link>
        </shared-drop-down>

    </div>
</div>
